export function isValidAbsoluteHttpUrl(value: string): boolean {
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return false;
  }

  let url: URL;

  try {
    url = new URL(trimmedValue);
  } catch {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
}

const TRACKING_PARAMETER_NAMES = new Set([
  '_hsenc',
  '_hsmi',
  'dclid',
  'fbclid',
  'gclid',
  'gbraid',
  'igsh',
  'igshid',
  'mc_cid',
  'mc_eid',
  'mkt_tok',
  'msclkid',
  'si',
  'vero_id',
  'wbraid',
  'yclid',
]);

const TRACKING_PARAMETER_PREFIXES = ['utm_', 'hsa_'];

export function removeTrackingParameters(value: string): string | null {
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return null;
  }

  let url: URL;

  try {
    url = new URL(trimmedValue);
  } catch {
    return null;
  }

  if (url.protocol !== 'http:' && url.protocol !== 'https:') {
    return null;
  }

  let removedTrackingParameter = false;

  for (const parameterName of Array.from(url.searchParams.keys())) {
    const normalizedName = parameterName.toLowerCase();
    const isTrackingParameter =
      TRACKING_PARAMETER_NAMES.has(normalizedName) ||
      TRACKING_PARAMETER_PREFIXES.some((prefix) => normalizedName.startsWith(prefix));

    if (isTrackingParameter) {
      url.searchParams.delete(parameterName);
      removedTrackingParameter = true;
    }
  }

  if (!removedTrackingParameter) {
    return null;
  }

  return url.toString();
}
